// extracted by mini-css-extract-plugin
module.exports = {"card":"_3VYJa","iconWrap":"_2U2hd","content":"z-XUn","title":"_3LXBD","subtitle":"_3w-od"};